// src/Pages/Cars.js
import React from "react";
import { Link } from "react-router-dom";

function Cars() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Cars</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link
          to="/cars/rent-car"
          className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition cursor-pointer"
        >
          <img
            src="https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg"
            alt="Rent Car"
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h2 className="text-lg font-semibold">Rent Car</h2>
          </div>
        </Link>

        <Link
          to="/cars/ride"
          className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition cursor-pointer"
        >
          <img
            src="https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg"
            alt="Ride"
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h2 className="text-lg font-semibold">Ride</h2>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Cars;